import storage, { MemoryStorage } from "local-storage-fallback";

/**
 * Check if a named storage mechanism is available and functional.
 *
 * @param {"localStorage" | "sessionStorage"} name - The storage type to check.
 * @returns {boolean} Whether the storage is available.
 */
function hasStorage(name) {
    try {
        const key = "TEST_KEY";
        const expected = "1";
        /** @type {Storage} */
        const store = window[name];
        store.setItem(key, expected);
        const actual = store.getItem(key);
        store.removeItem(key);
        return expected === actual;
    } catch (e) {
        return false;
    }
}

if (!hasStorage("localStorage")) {
    Object.defineProperty(window, "localStorage", {
        value: storage,
    });
}

if (!hasStorage("sessionStorage")) {
    Object.defineProperty(window, "sessionStorage", {
        value: new MemoryStorage(),
    });
}
